import color from '@theme/Colors';
import React, { SVGProps } from 'react';

type Props = {} & SVGProps<SVGSVGElement>;

export default function V2DashboardIcon(props: Props) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.2"
            stroke-linecap="round"
            stroke-linejoin="round"
            className="icon-svg-stroke"
            {...props}
        >
            <path d="M3 3v16a2 2 0 0 0 2 2h16" />
            <path d="M7 16h8" />
            <path d="M7 11h12" />
            <path d="M7 6h3" />
        </svg>
    );
}
